import { Box } from "@saleor/macaw-ui-next";
import { type HTMLAttributes } from "react";
import * as React from "react";

import { type GridTableProps } from "./types";

type GridTableRowElement = React.ElementRef<"tr">;
type GridTableRowProps = GridTableProps<HTMLAttributes<HTMLTableRowElement>> & {
  /**
   * 컬럼 머리글 행 표시 (2026-09-18 KST 추가).
   * GridTable 에는 thead 가 없어 머리글도 tbody 의 첫 행으로 그린다.
   * 대시보드 공통 머리글 배경(#f8f8f8)을 여기 한곳에서 입힌다.
   */
  header?: boolean;
  /**
   * 줄무늬로 칠할 행 (2026-09-18 KST 추가).
   * nth-child 로 하면 머리글이 tbody 첫 행이라 홀짝이 밀리고, 주문 상세형 표처럼
   * 한 덩어리가 여러 행에 걸치는 표를 못 맞춘다. 그래서 호출부가 직접 판단한다.
   */
  striped?: boolean;
};

export const GridTableRow = React.forwardRef<GridTableRowElement, GridTableRowProps>(
  ({ children, header, striped, ...props }, forwardedRef) => {
    return (
      // @ts-expect-error - incorrect types
      <Box
        as="tr"
        ref={forwardedRef}
        backgroundColor={header || striped ? "default2" : undefined}
        {...props}
      >
        {children}
      </Box>
    );
  },
);
GridTableRow.displayName = "GridTable.Row";
